import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=79406fd7&"
import script from "./configuration.vue?vue&type=script&lang=js&"
export * from "./configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79406fd7')) {
      api.createRecord('79406fd7', component.options)
    } else {
      api.reload('79406fd7', component.options)
    }
    module.hot.accept("./configuration.vue?vue&type=template&id=79406fd7&", function () {
      api.rerender('79406fd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/configuration.vue"
export default component.exports